import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AtingirMetaDTO, CalcularPMZDTO, CalcularTotaisDTO, Estoque, Estrutura, Precificacao, Relatorio, SelecionarEstruturasDTO } from './precificacao';

@Injectable({
    providedIn: 'root'
})

export class PrecificacaoService {

    private environmentUrl: string = '';

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

    getFiliais(): Observable<Estoque[]> {
        let url = this.environmentUrl + "/precificacao/filiais";
        return this.httpClient.get<Estoque[]>(url);
    }

    getRelatorios(): Observable<Relatorio[]> {
        let url = this.environmentUrl + "/precificacao/relatorios";
        return this.httpClient.get<Relatorio[]>(url);
    }

    getEstruturas(): Observable<Estrutura[]> {
        let url = this.environmentUrl + "/precificacao/estruturas";
        return this.httpClient.get<Estrutura[]>(url);
    }

    getPrecificacao(): Observable<Precificacao[]> {
        let url = this.environmentUrl + "/precificacao";
        return this.httpClient.get<Precificacao[]>(url);
    }

    selecionarEstruturas( filtro: SelecionarEstruturasDTO) {
        let url = this.environmentUrl + "/precificacao/selecionarEstruturas";
        return this.httpClient.post(url, filtro);
      }

    calcularPMZ( filtro: CalcularPMZDTO) {
        let url = this.environmentUrl + "/precificacao/calcularPMZ";
        return this.httpClient.post(url, filtro);
      }

    calcularTotais( filtro: CalcularTotaisDTO) {
        let url = this.environmentUrl + "/precificacao/calcularTotais";
        return this.httpClient.post(url, filtro);
    }

    atingirMeta( filtro: AtingirMetaDTO) {
        let url = this.environmentUrl + "/precificacao/atingirMeta";
        return this.httpClient.post(url, filtro);
    }
}